export default {
  feedbackStart: `Search feedback:`,
  feedbackMessage: 'Were these results helpful?',
  successMessage: 'Thanks for your feedback!'
}
